<style scoped>
  .browser_title {
    color: red;
    text-align: center;
    border-bottom: 1px solid #e9eaec;
    height: 40px;
    line-height: 25px;
    font-size: 16px;
    margin-bottom: 16px;
    font-weight: 700;
  }

  .app {
    height: 100%;
  }

  .right-menu {
    position: fixed;
    background: #fff;
    border: solid 1px rgba(0, 0, 0, .2);
    border-radius: 3px;
    z-index: 999;
    display: none;
  }

  .right-menu a {
    width: 75px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    display: block;
    color: #1a1a1a;
  }

  .right-menu a:hover {
    background: #eee;
    color: #fff;
  }

  html,
  body {
    height: 100%;
  }

  .right-menu {
    border: 1px solid #eee;
    box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, .1);
    border-radius: 1px;
    z-index: 99999999;
  }

  a {
    text-decoration: none;
  }

  .right-menu a {
    padding: 2px;
  }

  .right-menu a:hover {
    background: #42b983;
  }

</style>

<template>
  <div class="app">
    <router-view ref="router"></router-view>
    <context-menu class="right-menu" :target="contextMenuTarget" :show="contextMenuVisible"
                  @update:show="(show) => contextMenuVisible = show">
      <a href="javascript:;" @click="refush">刷 新</a>
      <!-- <a href="javascript:;" @click="clearCache">清除缓存</a> -->
    </context-menu>
  </div>
</template>
<script>
  export default {
    name: 'App',
    data() {
      return {
        contextMenuVisible: false,
        contextMenuTarget: document.body
      }
    },
    methods: {
      //刷新
      refush() {
        location.reload(true)
        this.contextMenuVisible = false;
      },
      //清除缓存
      clearCache() {
        document.getElementById('allLoadingBox').style.display = 'block'
        localStorage.clear()
        this.$store.dispatch('getBaseInfo').then(() => {
          document.getElementById('allLoadingBox').style.display = 'none'
          this.contextMenuVisible = false
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/App.vue